import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { generatePath } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as ROUTES from '#client/constants/routes';
import { useBusinessEntityInfo } from '#client/hooks/useBusinessEntityInfo';

import PlanChip from './PlanChip';
import * as Styled from './ProfileHeader.styles';
import ProfileHeaderLoadingState from './ProfileHeaderLoadingState';

function ProfileHeader() {
  const { businessEntityInfo, loading } = useBusinessEntityInfo();
  const { businessEntityUuid } = useBusinessEntity();

  if (loading) return <ProfileHeaderLoadingState />;

  const {
    name, nameInitials, planType, formationDate
  } = businessEntityInfo || {};

  return (
    <Card color="black">
      <CardContent size="lg">
        <Styled.Content>
          <Styled.EntityWrapper>
            <Styled.Avatar>
              {nameInitials}
            </Styled.Avatar>
            <Styled.TextContainer>
              <Text
                color="white"
                weight="medium"
                wrap="truncate"
              >
                {name}
              </Text>
              {formationDate && (
                <Text
                  style={{ color: 'rgba(255, 255, 255, 0.6)' }}
                  size="sm"
                  wrap="truncate"
                >
                  {`Formed: ${new Date(formationDate).toLocaleDateString('en-US')}`}
                </Text>
              )}
            </Styled.TextContainer>
          </Styled.EntityWrapper>
          <Styled.ProfileWrapper>
            <Stack
              orientation="horizontal"
              alignItems="center"
              gap={4}
              justifyContent="space-between"
              width="100%"
            >
              {planType && (
              <Stack orientation="horizontal" alignItems="center" gap={1}>
                <Text size="xs" weight="medium">
                  Plan:
                </Text>
                <PlanChip type={planType} />
              </Stack>
              )}
            </Stack>
            <Styled.ProfileButton
              clickstreamProps={{
                appSection: 'home',
                elementName: 'business_profile_header_business_profile_button',
                elementText: 'Business Profile'
              }}
              endIcon={<ArrowForwardIcon />}
              to={generatePath(ROUTES.entityProfile, { businessEntityUuid })}
            >
              Business Profile
            </Styled.ProfileButton>
          </Styled.ProfileWrapper>
        </Styled.Content>
      </CardContent>
    </Card>
  );
}

export default ProfileHeader;
